type Enum<E> = Record<keyof E, number | string> & { [k: number]: string };

export function keysOfEnum<E extends Enum<E>>(numericEnum: E) {
  return Object.keys(numericEnum).filter((key: number | string) =>
    isNaN(Number(numericEnum[key as number]))
  );
}
